/** Shown on View details / sample weekly menu surfaces. */
export const WEEKLY_MENU_INDICATIVE_NOTE =
  'This weekly menu is indicative for one sample week only. Dishes rotate week on week while staying within your selected plan.';
